// AUTO-GENERATED by tools/generate-world6.mjs. Do not edit by hand.
// Regenerate with: node tools/generate-world6.mjs
// W6 (Prism) — second paid-tier world. Dense lattices, 5-6 colors, d=6-8 mix.
import type { LevelDef } from '@tessera/engine';

export const WORLD_6_GENERATED: LevelDef[] = [
  // d*=6  branching=14.75  D=0.037  tiles=14
  {
    id: 'w6-l01',
    world: 6,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: -2, r: -1 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: 3, r: 0 }, color: 3 },
    ],
  },
  // d*=6  branching=18.29  D=0.074  tiles=11
  {
    id: 'w6-l02',
    world: 6,
    index: 2,
    radius: 4,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 4, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -4, r: 4 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -4 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -4, r: 1 }, color: 0 },
    { coord: { q: -3, r: -1 }, color: 0 },
    { coord: { q: -4, r: 2 }, color: 0 },
    { coord: { q: 4, r: -2 }, color: 1 },
    { coord: { q: 1, r: -4 }, color: 1 },
    { coord: { q: 4, r: -1 }, color: 1 },
    { coord: { q: -3, r: 4 }, color: 2 },
    { coord: { q: -2, r: 4 }, color: 2 },
    ],
  },
  // d*=6  branching=21.85  D=0.128  tiles=12
  {
    id: 'w6-l03',
    world: 6,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 3 },
    { coord: { q: 3, r: -2 }, color: 3 },
    ],
  },
  // d*=7  branching=18.13  D=0.216  tiles=13
  {
    id: 'w6-l04',
    world: 6,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 3 },
    { coord: { q: -3, r: 2 }, color: 3 },
    ],
  },
  // d*=7  branching=20.20  D=0.226  tiles=12
  {
    id: 'w6-l05',
    world: 6,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: 0, r: -3 }, color: 3 },
    ],
  },
  // d*=7  branching=18.99  D=0.260  tiles=13
  {
    id: 'w6-l06',
    world: 6,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: -3, r: 0 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 3 },
    { coord: { q: -3, r: 2 }, color: 3 },
    ],
  },
  // d*=7  branching=22.47  D=0.267  tiles=13
  {
    id: 'w6-l07',
    world: 6,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 2 },
    { coord: { q: 3, r: -2 }, color: 3 },
    { coord: { q: 3, r: -3 }, color: 3 },
    ],
  },
  // d*=7  branching=18.03  D=0.274  tiles=13
  {
    id: 'w6-l08',
    world: 6,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 2 },
    { coord: { q: -3, r: 3 }, color: 3 },
    { coord: { q: -1, r: 3 }, color: 3 },
    ],
  },
  // d*=7  branching=21.62  D=0.292  tiles=12
  {
    id: 'w6-l09',
    world: 6,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 2 },
    { coord: { q: 0, r: -3 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 3 },
    { coord: { q: -1, r: 3 }, color: 3 },
    ],
  },
  // d*=7  branching=19.25  D=0.344  tiles=11
  {
    id: 'w6-l10',
    world: 6,
    index: 10,
    radius: 4,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 2, r: -4 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -4, r: 4 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 4 }, color: 0 },
    { coord: { q: -3, r: 4 }, color: 0 },
    { coord: { q: 0, r: 4 }, color: 0 },
    { coord: { q: 4, r: -2 }, color: 1 },
    { coord: { q: 4, r: -4 }, color: 1 },
    { coord: { q: 4, r: -3 }, color: 1 },
    { coord: { q: -4, r: 0 }, color: 2 },
    { coord: { q: -1, r: -3 }, color: 2 },
    ],
  },
];
